import { render, staticRenderFns } from "./CreateDataAnalysis.vue?vue&type=template&id=779e959e&scoped=true"
import script from "./CreateDataAnalysis.vue?vue&type=script&lang=js"
export * from "./CreateDataAnalysis.vue?vue&type=script&lang=js"
import style0 from "./CreateDataAnalysis.vue?vue&type=style&index=0&id=779e959e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779e959e",
  null
  
)

export default component.exports